import { createFileRoute, redirectUnauthenticated } from '@frontend/web/utils/router';
import { handleOnboardingCompleteBeforeLoad } from '@frontend/web/utils/routing/handleRedirectBeforeLoad';

export const Route = createFileRoute('/onboarding/complete')({
  beforeLoad: async ({ context, location }) => {
    redirectUnauthenticated({ context, location });
    handleOnboardingCompleteBeforeLoad({ context, location });
  },
});
